import axios from '@/plugins/axios'
import { MessageBox, Message } from 'element-ui'
import isEmpty from 'lodash/isEmpty'

export default {
  namespaced: true,

  state: {
    loading: false,
    dialog: false,
    dialog_campaign: false,
    dialog_deposit: false,
    data: {
      dollar: 0,
      vidCents: 0
    },
    paymentHistory: [],
    tracks: [],
    campaigns: [],
    campaign: {
      id: null,
      name: '',
      amount: 0,
      track_id: null,
      start: null,
      end: null
    }
  },

  mutations: {
    setDialog(state, payload) {
      state.dialog = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setData(state, payload) {
      state.data = payload
    },
    setPaymentHistory(state, payload) {
      state.paymentHistory = payload
    },
    setDialogCampaign(state, payload) {
      state.dialog_campaign = payload
    },
    setCampaign(state, payload) {
      state.campaign = payload
    },
    setCampaigns(state, payload) {
      state.campaigns = payload
    },
    setCampaignDeposit(state, status) {
      state.dialog_deposit = status
    },
    setTracks(state, payload) {
      state.tracks = payload
    }
  },

  actions: {
    getBalance({ commit }) {
      commit('setLoading', true)
      axios.artist
        .get('balance')
        .then(r => {
          commit('setLoading', false)
          commit('setData', r.data.data)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    setpayment({ commit, dispatch }, payment) {
      axios.artist
        .post('payment', {
          amount: payment.amount,
          payment_method_nonce: payment.nonce
        })
        .then(() => {
          dispatch('getBalance')
          dispatch('getPaymentHistory')
          commit('setLoading', false)
          commit('setDialog', false)
        })
        .catch(err => {
          commit('setLoading', false)
          commit('setDialog', false)
          if (err.response.data && err.response.data.response.message) {
            Message({
              type: 'error',
              message: err.response.data.response.message
            })
          }
        })
    },
    getPaymentHistory({ commit }) {
      commit('setLoading', true)
      axios.artist
        .get('paymenthistory')
        .then(r => {
          commit('setLoading', false)
          commit('setPaymentHistory', r.data.data)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    async createCampaign({ commit, dispatch, state }) {
      return await axios.artist
        .post(`campaign/create`, {
          name: state.campaign.name,
          track_id: state.campaign.track_id,
          amount: state.campaign.amount,
          start: state.campaign.start,
          end: state.campaign.end
        })
        .then(() => {
          commit('setDialogCampaign', false)
          dispatch('readCampaign')
          return 1
        })
        .catch(() => {
          commit('setDialogCampaign', false)
          return 0
        })
    },
    readCampaign({ dispatch, commit }) {
      commit('setLoading', true)
      axios.artist
        .get('campaign', {
          params: {
            artist:
              this.state.artistDashboard.artist_label !== null
                ? this.state.artistDashboard.artist_label.id
                : null
          }
        })
        .then(r => {
          let campaign = r.data.data,
            temp = {}
          commit('setLoading', false)

          campaign.map(s => {
            let vc_invested = 0
            s.vc_campaign_track.vc_invested.map(a => {
              vc_invested = vc_invested + a.amount
            })
            s.vc_campaign_track.vc_invested = vc_invested
          })

          commit('setCampaigns', campaign)

          temp = this.state.artistTrackVidCents.active_campaign
          commit('artistTrackVidCents/setActiveCampaign', {}, { root: true })
          commit('artistTrackVidCents/setTracks', [], { root: true })
          if (!isEmpty(temp)) {
            for (let i = 0; i < campaign.length; i++) {
              if (campaign[i].id == temp.id) {
                temp = campaign[i]
                break
              }
            }

            commit('artistTrackVidCents/setActiveCampaign', temp, {
              root: true
            })
            dispatch('artistTrackVidCents/readTracks', null, { root: true })
          } else if (campaign.length > 0) {
            commit('artistTrackVidCents/setActiveCampaign', campaign[0], {
              root: true
            })
            dispatch('artistTrackVidCents/readTracks', null, { root: true })
          }
          dispatch('getBalance')
        })
        .catch(() => {
          commit('setCampaigns', [])
          commit('artistTrackVidCents/setActiveCampaign', null, { root: true })
          dispatch('artistTrackVidCents/readTracks', null, { root: true })
          commit('setLoading', false)
          dispatch('getBalance')
        })
    },
    depositCampaign({ state, dispatch, commit }, deposit) {
      MessageBox.confirm(
        `You will deposit ${deposit} VC to ${state.campaign.name} campaign. Continue?`,
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          axios.artist
            .post(
              `campaign/${state.campaign.vc_campaign_track.id}/deposit/${deposit}`
            )
            .then(() => {
              commit('setCampaignDeposit', false)
              dispatch('readCampaign')
              dispatch('getBalance')
            })
            .catch(err => {
              if (err.response.data && err.response.data.response.message) {
                Message({
                  type: 'error',
                  message: err.response.data.response.message
                })
              }
            })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: 'Deposit cancelled'
          })
        })
    },
    getTracks({ commit }) {
      commit('setLoading', true)
      axios.artist
        .get('campaign/track')
        .then(r => {
          commit('setLoading', false)
          commit('setTracks', r.data.data)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  }
}
